import { Box, Text } from '@factorialco/deprecated-design-system'

import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useExternalLinks, { EventPayload } from 'modules/onboarding/hooks/useExternalLinks'
import { getHelpCenterLocalizedLink } from 'modules/onboarding/lib/helpWidget'

import './index.styles.css'
const PopularLinks = ({
  links,
  eventPayload,
}: {
  links: Array<{ text: string; link: string }>
  eventPayload: EventPayload
}) => {
  const { handleExternalClick } = useExternalLinks()

  return (
    <>
      {links.map((item, index) => (
        <Box
          key={index}
          alignItems="center"
          paddingX="s16"
          paddingY="s12"
          flexDirection="row"
          gap="s8"
          cursor="pointer"
          className={'PopularTopics_listItem'}
          onClick={() =>
            handleExternalClick(
              trackingEvents.onboarding.goToHelpCenterLink,
              eventPayload,
              item.link
            )
          }
        >
          <Text.Normal size="200" color="viridian1200" weight="medium">
            {item.text}
          </Text.Normal>
          <Box flexNoShrink>
            <Box
              style={{
                color: 'viridian1200',
                backgroundImage: `url('assets/images/external-link.svg')`,
                backgroundPosition: 'center',
                width: '20px',
                height: '20px',
              }}
            />
          </Box>
        </Box>
      ))}
    </>
  )
}

type OnboardingRecommendedItemProps = {
  links: Array<{ text: string; link: string }>
}

type Props = {
  locale: string
  eventPayload: EventPayload
}

const PopularTopics = ({ locale, eventPayload }: Props) => {
  const popularTopics: OnboardingRecommendedItemProps = {
    links: [
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.essential_handbook'),
        link: getHelpCenterLocalizedLink(locale, 'essential_handbook'),
      },
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.time_tracking_guide'),
        link: getHelpCenterLocalizedLink(locale, 'time_tracking_guide'),
      },
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.time_planning_tools'),
        link: getHelpCenterLocalizedLink(locale, 'time_planning_tools'),
      },
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.time_off_guide'),
        link: getHelpCenterLocalizedLink(locale, 'time_off_guide'),
      },
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.permissions_guide'),
        link: getHelpCenterLocalizedLink(locale, 'permissions_guide'),
      },
      {
        text: i18n.t('help_widget.sidepanel.popular_topics.download_factorial'),
        link: getHelpCenterLocalizedLink(locale, 'download_factorial'),
      },
    ],
  }

  return (
    <Box gap="s16">
      <Text size="100" color="grey800" weight="bold" caps>
        {i18n.t('help_widget.sidepanel.popular_topics.title')}
      </Text>
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{ all: 'abs008' }}
      >
        <PopularLinks links={popularTopics.links} eventPayload={eventPayload} />
      </Box>
    </Box>
  )
}

export default PopularTopics
